import React from "react";
import { useNavigate } from "react-router-dom";
import "./PhysicalCard.css";

export default function PhysicalCard() {
  const navigate = useNavigate();
  return (
    <div className="info-page">
      {/* Header */}
      <div className="info-header">
        <button className="info-back" onClick={() => navigate("/card")}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6"/>
          </svg>
        </button>
        <span className="info-title">Physical Card</span>
        <span style={{width:22}}/>
      </div>

      {/* Hero */}
      <div className="info-hero">
        {/* Card visual */}
        <div className="ipc-card-visual">
          <div className="ipc-card-top">
            <span className="ipc-brand">eToro</span>
            <span className="ipc-tier">◆ GOLD</span>
          </div>
          <div className="ipc-chip"/>
          <div className="ipc-number">•••• •••• •••• 4242</div>
          <div className="ipc-bottom">
            <div>
              <div className="ipc-label">CARD HOLDER</div>
              <div className="ipc-name">YOUR NAME</div>
            </div>
            <span className="ipc-visa">VISA</span>
          </div>
        </div>

        <div className="info-tier-badge">🥇 Available from Gold &amp; above</div>
        <p className="info-hero-sub">
          A premium Visa card delivered to your door — built for everyday spending and travel.
        </p>
      </div>

      {/* Steps */}
      <div className="info-steps-wrap">
        <div className="info-section-label">HOW TO ORDER</div>

        <div className="info-step">
          <div className="info-step-num">1</div>
          <div className="info-step-body">
            <div className="info-step-title">Confirm your delivery address</div>
            <div className="info-step-desc">Go to Profile → Address and make sure your details are current before ordering.</div>
          </div>
        </div>
        <div className="info-step">
          <div className="info-step-num">2</div>
          <div className="info-step-body">
            <div className="info-step-title">Request your card</div>
            <div className="info-step-desc">Tap "Order Physical Card" below and confirm your shipping details. Processing takes 1–2 business days.</div>
          </div>
        </div>
        <div className="info-step">
          <div className="info-step-num">3</div>
          <div className="info-step-body">
            <div className="info-step-title">Receive &amp; activate</div>
            <div className="info-step-desc">Your card arrives within 5–10 business days. Activate it in the app as soon as it arrives.</div>
          </div>
        </div>
        <div className="info-step">
          <div className="info-step-num">4</div>
          <div className="info-step-body">
            <div className="info-step-title">Set your PIN</div>
            <div className="info-step-desc">Choose your PIN securely through the app — no hotline needed.</div>
          </div>
        </div>
      </div>

      <div className="info-note">
        <span className="info-note-icon">ℹ️</span>
        <span className="info-note-text">Your virtual card stays active while you wait. You can freeze or cancel either card independently at any time.</span>
      </div>

      <div className="info-actions">
        <button className="info-btn-primary">Order Physical Card →</button>
        <button className="info-btn-outline" onClick={() => navigate("/card")}>← Back to Card</button>
      </div>
    </div>
  );
}
